// eslint-disable-next-line import/prefer-default-export
export const invertedMessages = {
  Clear: 'CERTS_CLEAR',
  'Remove Filter': 'CERTS_REMOVE_FILTER',
  'Add Filter': 'CERTS_ADD_FILTER',
  'No data available': 'CERTS_NO_DATA_AVAILABLE',
  Search: 'Popup.SearchForm',
  User: 'User_LABEL.ATTESTATIONS',
  Account: 'Account_LABEL.ATTESTATIONS',
  Entitlement: 'Ent_LABEL.ATTESTATIONS',
  Role: 'Role_LABEL.ATTESTATIONS',
  'Child Entitlement': 'Ent2_LABEL.ATTESTATIONS',
  // need db changes
  Loading: 'CERTS_LOADER',
  'Clear Filter': 'CERTS_CLEAR_FILTER',
  'Clear All': 'CERTS_CLEAR_ALL',
  'See Results ({totalItems})': 'CERTS_FILTER_RESULTS',
  'Applied to: {types}': 'CERTS_APPLIED_TO_TYPES',
  Close: 'CloseLabel',
};
